import { MapPin, Phone, Mail } from "lucide-react";
import { PHONE, CALL_URL } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-stone-900 text-stone-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <img
              src="https://vingrace.com/wp-content/uploads/2023/06/vingrace-1.png"
              alt="Vin Grace"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed text-stone-400">
              India's No.1 Accessibility & Mobility Solutions Provider. Empowering independence since 2007.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-['Outfit']">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <a href={CALL_URL} className="flex items-center gap-2 hover:text-amber-400 transition-colors">
                <Phone className="w-4 h-4 text-amber-500" />
                +91 {PHONE}
              </a>
              <a href="mailto:shhrey@vingrace.com" className="flex items-center gap-2 hover:text-amber-400 transition-colors">
                <Mail className="w-4 h-4 text-amber-500" />
                shhrey@vingrace.com
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" />
                <span>A-111 Lajpat Nagar 1, New Delhi - 110024</span>
              </div>
            </div>
          </div>

          {/* Stair Lifts */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-['Outfit']">Our Stair Lifts</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="https://vingrace.in/acorn-outdoor-stair-lift/" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors">Outdoor Stair Lifts</a></li>
              <li><a href="https://vingrace.in/acorn-superglide-130-stair-lift/" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors">Acorn Superglide 130</a></li>
              <li><a href="https://vingrace.in/otolift-curved-chair-lift/" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors">Otolift Curved Chair Lift</a></li>
              <li><a href="https://vingrace.in/platinum-ergo-straight-stairlift/" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors">Platinum Ergo Straight</a></li>
              <li><a href="https://vingrace.in/platform-wheelchair-stairlift/" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors">Wheelchair Platform Lift</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-stone-500">
          <span>&copy; {new Date().getFullYear()} Vin Grace. All Rights Reserved.</span>
          <div className="flex items-center gap-4">
            <a href="https://vingrace.in/privacy-policy/" target="_blank" rel="noopener noreferrer" className="hover:text-stone-300 transition-colors">Privacy Policy</a>
            <a href="https://vingrace.in/terms-conditions/" target="_blank" rel="noopener noreferrer" className="hover:text-stone-300 transition-colors">Terms & Conditions</a>
            <span>Serving all of India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
